import {
  IPutSurveyContentPayload,
  getSurveyContentsRequest,
  getSurveyOverviewRequest,
  putSurveyContentsRequest,
} from '../services/surveys';

export const useSurveyOverview = () => {
  const getSurveyContents = async (id: string) => {
    const contents = await getSurveyContentsRequest(id);
    return contents;
  };

  const getSurveyOverview = async (id: string) => {
    const overview = await getSurveyOverviewRequest(id);
    return overview;
  };

  const putSurveyContents = async (id: string, payload: IPutSurveyContentPayload) => {
    return await putSurveyContentsRequest(id, payload);
  };

  return { getSurveyOverview, getSurveyContents, putSurveyContents };
};
